export default __webpack_public_path__ + "af69d27dd0530b2561a396e3a4d4d8b6.svg";